<div class="col-md-12 pageTitle">
  <label class="pt-4 pl-4">Clinic Transaction Details</label>
</div>
<div class="col-md-12 mt-3">
  <div class="row justify-content-end">
    <div class="col-md-2">
      <ng-select [items]="clinicList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
        placeholder="Select Clinic" (change)="onClinicChange($event)" [(ngModel)]="clinic_selected">
      </ng-select>
    </div>
    <div class="col-md-2">
      <ng-container>
        <ng-select [items]="doctorList" bindLabel="name" [clearable]="false" [addTag]="false" [multiple]="false"
          placeholder="Select Doctor" (change)="onChange($event)" [(ngModel)]="doctor_selected">
          <ng-template ng-option-tmp let-item="item">
            <div title="{{item.name}}">{{item.name}}</div>
          </ng-template>
        </ng-select>
      </ng-container>
    </div>
    <div class="col-md-2">
      <label for="searchBoxInv" class="searchBoxlbl"><em class="fa fa-search"></em></label>
      <input type="text" name="searchBoxInv" id="searchBoxInv" class="form-control input-font searchBox pl-5"
        [(ngModel)]="searchBoxInv" placeholder="Invoice Number" (keyup.enter)="fetchTransactionList()">
    </div>
    <div class="col-md-2">
      <label for="searchBoxCus" class="searchBoxlbl"><em class="fa fa-search"></em></label>
      <input type="text" name="searchBoxCus" id="searchBoxCus" class="form-control input-font searchBox pl-5"
        [(ngModel)]="searchBoxCus" placeholder="Mobile Number" (keyup.enter)="fetchTransactionList()">
    </div>
    <div class="col-md-3">
      <my-date-range-picker name="mydaterange" [options]="myDateRangePickerOptions" [(ngModel)]="dateRange" required
        (dateRangeChanged)="changeDate($event)">
      </my-date-range-picker>
    </div>
  </div>
  <div class="table-responsive pl-10 pr-10">
    <table class="table table-hover table-bordered">
      <thead class="turTable">
        <tr class="">
          <th class="cellHeader text-center">Date</th>
          <th class="cellHeader text-center">Transaction ID</th>
          <th class="cellHeader text-center">Invoice No.</th>
          <th class="cellHeader text-center">Owner Name</th>
          <th class="cellHeader text-center">Pet Name</th>
          <th class="cellHeader text-center">Doctor Name</th>
          <th class="cellHeader text-center">Transaction Channel <em class="text-warning fa fa-info-circle"
              title="Transaction Channel(UPI, Cash, Card)"></em></th>
          <!-- <th class="cellHeader text-center">Channel <em class="text-warning fa fa-info-circle"
              title="Channel(Clinic / Phone)"></em></th> -->
          <th class="cellHeader text-center">Transaction Amount</th>
          <!-- <th class="cellHeader text-center">Invoice View</th> -->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of transactionList">
          <td class="cellValue">{{item?.updated_at | date:'dd-MM-yyyy'}}</td>
          <td class="cellValue">{{item?.payment_no}}</td>
          <td class="cellValue">{{item?.invoices[0]?.invoiceid}}</td>
          <td class="cellValue">{{item?.customer?.first_name}} {{item?.customer?.last_name}}</td>
          <td class="cellValue">{{item?.pet?.name}}</td>
          <td class="cellValue">{{item?.doctor?.first_name}} {{item?.doctor?.last_name}}</td>
          <td class="cellValue text-center">{{item?.payment_method}}</td>
          <!-- <td class="cellValue text-center">{{item?.payment_no}}</td> -->
          <td class="cellValue text-center">&#8377; {{item?.amount}}</td>
          <!-- <td class="cellValue text-center">{{item?.payment_no}}</td> -->
        </tr>
      </tbody>

    </table>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent($event)">
  </mat-paginator>
</div>
